import { StandardEvents } from "@shopify/events";

/**
 * THEF: houdt eigen variant-afhankelijke blokken (bundel, bundelkorting, levering, info) gelijk met de gekozen variant.
 * Zelfde patroon als Horizon product-price.js: luister op de sectie naar shopify:product:select, wacht op de
 * herrenderde sectie (detail.html, Section Rendering API) en vervang dit blok door dezelfde data-block-id daaruit.
 */
class ThefVariantSync extends HTMLElement {
  connectedCallback() {
    this.section = this.closest(".shopify-section, dialog");
    this.section?.addEventListener(StandardEvents.productSelect, this.onSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(
      StandardEvents.productSelect,
      this.onSelect,
    );
  }

  onSelect = (event) => {
    if (
      !(event.target instanceof Element) ||
      event.target.closest("product-card")
    )
      return;
    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html || !this.isConnected) return;
        const fresh = html.querySelector(
          `thef-variant-sync[data-block-id="${this.dataset.blockId}"]`,
        );
        if (fresh) this.replaceChildren(...fresh.childNodes);
      })
      .catch((error) => {
        if (error?.name !== "AbortError")
          console.warn("[thef-variant-sync]", error);
      });
  };
}

if (!customElements.get("thef-variant-sync"))
  customElements.define("thef-variant-sync", ThefVariantSync);
